import { useQuery } from '@tanstack/react-query';
import { menuCategoryRequests } from '@/lib/api/requests/menu-categories';
import { menuCategoryKeys } from './keys';

/** A concept's menu categories, in their saved order. Off until a concept is chosen. */
export function useMenuCategories(companyId: number | null | undefined, enabled = true) {
  return useQuery({
    queryKey: menuCategoryKeys.list(companyId ?? null),
    queryFn: () => menuCategoryRequests.list(companyId as number),
    enabled: enabled && companyId != null,
    staleTime: 60 * 1000,
    // Switching concept re-keys the query; keep the last list on screen rather
    // than collapsing the chip bar to "All" for a beat.
    placeholderData: (previousData) => previousData,
  });
}
